var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParentPortal',{attrs:{"tabs":_vm.sidePanelComponents}},[(_vm.report)?_c('router-view',{staticClass:"main-content",attrs:{"report":_vm.report}}):(_vm.loadError)?_c('div',{staticClass:"main-content p-4"},[_vm._v(" Unable to load this report. ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }